import { createAction, props } from '@ngrx/store';

// Interfaces
import { IJobPosition } from '../../../shared/interfaces/job-position.interface';

// Listar Usuarios action
export const uploadJobPositions = createAction('[ADMIN_USER] Cargar Lista de Cargos');

// Devuelve los datos de los cargos si se obtuvieron correctamente
export const listJobPositionsSuccess = createAction(
  '[ADMIN_USER] Listar Cargos Success',
  props<{ jobPositions: IJobPosition[] }>(),
);

// Devuelve el error si no se logran obtener los cargos
export const listJobPositionsError = createAction(
  '[ADMIN_USER] Listar Cargos Error',
  props<{ payload: any }>(),
);
